import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { provideUserIdleConfig } from 'angular-user-idle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha-2";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouteGuardModule } from './components/route-guard/route-guard.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { CookieService } from 'ngx-cookie-service';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        NgxPaginationModule,
        NgMultiSelectDropDownModule.forRoot(),
        NgxMaskDirective,
        RouteGuardModule,
        AppRoutingModule,
        GoogleTagManagerModule.forRoot({
            id: 'AW-953199487',
        })
    ], 
    providers: [     
        CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        provideNgxMask(),
        provideUserIdleConfig({ idle: 900, timeout: 30, ping: 120 }) // This is the new way to configure.
        // provideUserIdleConfig({ idle: 30, timeout: 30, ping: 30 }) // 30 seconds used for testing
        ,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
